import { useState, useEffect } from 'react'
import { Dialog, DialogContent } from '@ui/components/ui/dialog'
import { useDataStore } from '@/lib/machine/use-data-store'
import { useFirmwareVersions } from '@/lib/firmware-update/use-firmware-versions'
import { useFirmwareInstall } from '@/lib/firmware-update/use-firmware-install'
import { FirmwareUpdateContent } from './firmware-update-content'

/** Auto-showing dialog on the dashboard. Opens when a firmware update is available. */
export function FirmwareUpdateDialog() {
  const versions = useFirmwareVersions()
  const isOnline = useDataStore(s => s.isOnline)
  const { state, isBusy, install, reset } = useFirmwareInstall()

  const [dismissed, setDismissed] = useState(false)

  // Reset dismissal when the target version changes
  const [lastTarget, setLastTarget] = useState<string | null>(null)
  useEffect(() => {
    if (versions.updateAvailable && versions.target !== lastTarget) {
      setDismissed(false)
      setLastTarget(versions.target)
    }
  }, [versions, lastTarget])

  const shouldShow = versions.updateAvailable && !dismissed

  const handleOpenChange = (open: boolean) => {
    if (!open && !isBusy) {
      setDismissed(true)
      reset()
    }
  }

  if (!versions.updateAvailable) return null

  return (
    <Dialog open={shouldShow} onOpenChange={handleOpenChange}>
      <DialogContent
        className="max-h-1/2 p-16 [&>button:last-child]:hidden"
        onPointerDownOutside={e => {
          if (isBusy) e.preventDefault()
        }}
        onEscapeKeyDown={e => {
          if (isBusy) e.preventDefault()
        }}
      >
        <FirmwareUpdateContent
          versions={versions}
          state={state}
          onInstall={install}
          onClose={() => handleOpenChange(false)}
          isOnline={isOnline}
        />
      </DialogContent>
    </Dialog>
  )
}
